import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const Undo = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M26.0416 16.6667C20.5208 16.6667 15.5208 18.7292 11.6666 22.0834L4.16663 14.5834V33.3334H22.9166L15.375 25.7917C18.2708 23.375 21.9583 21.875 26.0416 21.875C33.4166 21.875 39.6875 26.6875 41.875 33.3334L46.8125 31.7084C43.9166 22.9792 35.7291 16.6667 26.0416 16.6667Z"
        fill={color}
      />
    </svg>
  )
}
